module.exports = [{
      plugin: require('/Applications/MAMP/htdocs/shifra-new/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"typekit":{"id":"abr5yjc"}},
    },{
      plugin: require('/Applications/MAMP/htdocs/shifra-new/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-105402728-3"},
    }]
